import React from "react"

const UserStatusDropdown = ({ value, options = [], onChange, disabled = false, loading = false }) => {
    return (
        <div className={`status-select-wrap ${loading ? 'status-select-wrap--loading' : ''}`}>
            <select
                className="status-select"
                value={value}
                disabled={disabled || loading}
                onChange={(event) => onChange?.(Number(event.target.value))}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            <span className="status-select-caret" aria-hidden="true">
                ▾
            </span>
        </div>
    )
}

export default UserStatusDropdown
